import { formatMessageIntlUtil } from '@gymaholic/packages'
import ButtonPrimary from 'components/ButtonPrimary'
import ContentBoxBackgroundContent from 'components/ContentBoxBackgroundContent'
import TextBodySmall from 'components/TextBodySmall'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import { View } from 'components/View'
import CartProduct from 'containers/Checkout/CartProduct'
import { getCartProductsCartSelector } from 'modules/cart/selectors/get-cart-products'
import { getDiscountCartSelector } from 'modules/cart/selectors/get-discount'
import { getSubTotalPriceCartSelector } from 'modules/cart/selectors/get-sub-total'
import { getTotalPriceCartSelector } from 'modules/cart/selectors/get-total'
import { getNameCurrencySelector } from 'modules/currencies/selectors'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import {
  STYLES_COLOR,
  STYLES_FONT_WEIGHT,
  STYLES_MARGIN
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import {
  defineMessages,
  FormattedNumber
} from 'react-intl'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import getPriceStringUtil from 'utils/string/get-price'
import WithIntl from 'components/WithIntl'
import HolidayDelays from 'containers/HolidayDelays/index.js'

const messages = defineMessages({
  title: {
    id: 'CartDetailsContainer.title',
    defaultMessage: 'Cart',
    description: 'The title.'
  },
  subTotal: {
    id: 'CartDetailsContainer.subTotal',
    defaultMessage: 'Subtotal',
    description: 'The sub total.'
  },
  total: {
    id: 'CartDetailsContainer.total',
    defaultMessage: 'Total',
    description: 'The total.'
  },
  discount: {
    id: 'CartDetailsContainer.discount',
    defaultMessage: 'Discount',
    description: 'The discount.'
  },
  storeButton: {
    id: 'CartDetailsContainer.storeButton',
    defaultMessage: 'Store',
    description: 'The store button.'
  },
  checkoutButton: {
    id: 'CartDetailsContainer.checkoutButton',
    defaultMessage: 'Checkout',
    description: 'The checkout button.'
  }
})

class CartDetailsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.handleClickCheckout = this.handleClickCheckout.bind(this)
  }

  handleClickCheckout () {
    this.props.dispatch(openModalAction(MODAL_ID.CHECKOUT))
  }

  renderCheckoutButton () {
    if (!this.props.cartProducts.length) {
      return
    }
    return (
      <ButtonPrimary
        onClick={this.handleClickCheckout}
        w
      >
        {formatMessageIntlUtil(this.props.intl, messages.checkoutButton)}
      </ButtonPrimary>
    )
  }

  renderStoreButton () {
    const isStore = (
      this.props.match.params.section ===
      SECTIONS_NAME.STORE &&
      this.props.match.params.slug !==
      'cart'
    )
    if (isStore || this.props.cartProducts.length) {
      return
    }
    return (
      <div>
        <ButtonPrimary
          url={ROUTE_PATH.STORE}
          w
        >
          {formatMessageIntlUtil(this.props.intl, messages.storeButton)}
        </ButtonPrimary>
      </div>
    )
  }

  renderProducts () {
    if (!this.props.cartProducts.length) {
      return
    }
    return (
      <View
        style={{
          alignItems: View.ALIGN.START
        }}
      >
        {this.props.cartProducts.map((cartProduct, index) => {
          return (
            <CartProduct
              key={index}
              value={cartProduct}
            />
          )
        })}
      </View>
    )
  }

  renderSubTotal () {
    if (!this.props.cartProducts.length) {
      return
    }
    return (
      <section>
        <View
          style={{
            marginBottom: STYLES_MARGIN.SMALL,
            flexDirection: View.DIRECTION.ROW,
            textAlign: 'left'
          }}
        >
          <div style={{ flexGrow: '1' }}>
            <TextBodySmall
              style={{
                fontWeight: STYLES_FONT_WEIGHT.BOLD
              }}
            >
              {formatMessageIntlUtil(this.props.intl, messages.subTotal)}
            </TextBodySmall>
          </div>
          <div>
            <FormattedNumber
              currency={this.props.currencyName}
              style='currency'
              value={getPriceStringUtil(this.props.subTotalPrice)}
            />
          </div>
        </View>
      </section>
    )
  }

  renderDiscount () {
    if (!this.props.cartProducts.length) {
      return
    }
    const { discount } = this.props
    if (!discount) {
      return
    }
    return (
      <View
        style={{
          color: STYLES_COLOR.BLUE,
          marginBottom: STYLES_MARGIN.SMALL,
          flexDirection: View.DIRECTION.ROW,
          textAlign: 'left'
        }}
      >
        <div style={{ flexGrow: '1' }}>
          <TextBodySmall
            style={{
              fontWeight: STYLES_FONT_WEIGHT.BOLD
            }}
          >
            {formatMessageIntlUtil(this.props.intl, messages.discount)}
          </TextBodySmall>
        </div>
        <div>
          <span>
            <span>-</span>
            <FormattedNumber
              currency={this.props.currencyName}
              style='currency'
              value={getPriceStringUtil(discount)}
            />
          </span>
        </div>
      </View>
    )
  }

  renderTotal () {
    if (!this.props.cartProducts.length) {
      return
    }
    return (
      <View
        style={{
          marginBottom: STYLES_MARGIN.BIG,
          flexDirection: View.DIRECTION.ROW,
          textAlign: 'left'
        }}
      >
        <div style={{ flexGrow: '1' }}>
          <TextBodySmall
            style={{
              fontWeight: STYLES_FONT_WEIGHT.BOLD
            }}
          >
            {formatMessageIntlUtil(this.props.intl, messages.total)}
          </TextBodySmall>
        </div>
        <div>
          <FormattedNumber
            currency={this.props.currencyName}
            style='currency'
            value={getPriceStringUtil(this.props.totalPrice)}
          />
        </div>
      </View>
    )
  }

  renderTitle () {
    return (
      <View mb>
        <TextTitleCondensed>
          {formatMessageIntlUtil(this.props.intl, messages.title)}
        </TextTitleCondensed>
      </View>
    )
  }

  render () {
    return (
      <ContentBoxBackgroundContent>
        {this.renderTitle()}
        {this.renderStoreButton()}
        {this.renderProducts()}
        {this.renderSubTotal()}
        {this.renderDiscount()}
        {this.renderCheckoutButton()}
        <HolidayDelays />
        {/* <LoadCurrencies /> */}
      </ContentBoxBackgroundContent>
    )
  }
}

CartDetailsContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cartProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.object,
  intl: PropTypes.object.isRequired,
  currencyName: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  subTotalPrice: PropTypes.number.isRequired
}

const select = () => createSelector(
  getCartProductsCartSelector(),
  getNameCurrencySelector(),
  getSubTotalPriceCartSelector(),
  getDiscountCartSelector(),
  getTotalPriceCartSelector(),
  (cartProducts, currencyName, subTotalPrice, discount, totalPrice) => (
    {
      cartProducts,
      currencyName,
      subTotalPrice,
      discount,
      totalPrice
    }
  )
)

export default WithIntl(connect(select)(CartDetailsContainer))
